import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SendRequestMoneyService } from 'src/app/services/send-request-money.service'
import { SendMoneyService } from '../send-money/send-money.service';

// import {}

@Component({
  selector: 'app-request-recipient-add-form',
  templateUrl: './request-recipient-add-form.component.html',
  styleUrls: ['./request-recipient-add-form.component.scss']
})
export class RequestRecipientAddFormComponent implements OnInit {


  constructor(public requestService : SendRequestMoneyService, public router : Router, public auth:AuthService, public sendMoneyService : SendMoneyService) { }

  ngOnInit(): void {
    //console.log(this.requestService.request)
    if(!this.requestService.request){
      this.router.navigateByUrl('/dashboard')
    }

  }

  addAndApprove(addrecipientForm){
      let data = {
        id:this.requestService.request.id,
        status:1,
        ...addrecipientForm.value
      }
      this.auth.requestAction(data).subscribe(res => {
        //console.log(res)
        this.sendMoneyService.receiver = res['receiver']
        this.sendMoneyService.purpose = res['purpose']['reason']
        // this.sendMoneyService.purpose = this.sendMoneyService.caReasons.find(element => {
        //   return element.attributes.code == res['purpose']
        // })
        this.sendMoneyService.isAcknowlodgingRequest = true
        this.sendMoneyService.requestedSendingAmount = res['amount']
        this.router.navigateByUrl('/send-money/step3')

      }, err =>{
        //console.log(err)
      })
  }

}





// {amount: "0.29"
// bank_detail:
// account_number: "0119313506"
// address: null
// bank_code: "GTBANK PLC"
// bank_ifsc_code: null
// bank_name: "000058"
// contact_number: null
// country:
// capital: "Abuja"
// created_at: "2018-07-20T20:11:03.000000Z"
// currency: "NGN"
// emoji: "🇳🇬"
// emojiU: "U+1F1F3 U+1F1EC"
// flag: 1
// id: 161
// iso2: "NG"
// iso3: "NGA"
// name: "Nigeria"
// native: "Nigeria"
// phonecode: "234"
// updated_at: "2020-05-16T10:49:11.000000Z"
// wikiDataId: "Q1033"
// __proto__: Object
// country_id: 161
// created_at: "2021-01-30T08:14:21.000000Z"
// email: "prerna@eventao.com"
// id: 5
// name: "Prerna"
// nickname: null
// status: "1"
// updated_at: null
// user:
// created_at: "2021-01-18T17:00:46.000000Z"
// email: "prerna@eventao.com"
// email_verified_at: "2021-01-18T17:01:55.000000Z"
// id: 77
// lastname: "gour"
// name: "Prerna"
// refer_code: "fBBHxcgfCM"
// type: "ca"
// updated_at: "2021-01-28T06:27:58.000000Z"
// __proto__: Object
// user_id: 77
// __proto__: Object
// country: "Nigeria"
// created_at: "2021-02-12T07:03:11.000000Z"
// currency: "NGN"
// id: 29
// name: "prerna new"
// res_exist: 0
// user_name: "Prerna"}